import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": _vm.options.width
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.isValidating
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v(_vm._s(_vm.isAdding ? "Create custom data" : "Edit custom data"))])]), _c(VCardText, [_c(VForm, {
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c("div", [_c(VExpansionPanels, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c("span", {
    staticClass: "text-bold text-standalone-required"
  }, [_vm._v(" Left side on customs invoice ")])]), _c(VExpansionPanelContent, [_c("div", {
    staticClass: "dfwa-form"
  }, [_c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Title",
      placeholder: "title on left side (Importer by)",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.leftTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "leftTitle", $$v);
      },
      expression: "form.leftTitle"
    }
  })], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Name",
      placeholder: "Name",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.leftNameLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "leftNameLine", $$v);
      },
      expression: "form.leftNameLine"
    }
  })], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Address (main)",
      placeholder: "XX Street",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.leftAddressLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "leftAddressLine1", $$v);
      },
      expression: "form.leftAddressLine1"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Address (city)",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.leftAddressLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "leftAddressLine2", $$v);
      },
      expression: "form.leftAddressLine2"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Tax ID",
      placeholder: "Tax ID # XX-XXXXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.leftTaxIdLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "leftTaxIdLine", $$v);
      },
      expression: "form.leftTaxIdLine"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Import permit",
      placeholder: "TTB permit # AA-B-XXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.leftPermitLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "leftPermitLine", $$v);
      },
      expression: "form.leftPermitLine"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Bond ID",
      placeholder: "BOND # AAXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.leftPartnerLine3,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "leftPartnerLine3", $$v);
      },
      expression: "form.leftPartnerLine3"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Partner ID",
      placeholder: "PWDBW ID : XXXXXXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.leftPartnerLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "leftPartnerLine2", $$v);
      },
      expression: "form.leftPartnerLine2"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Partner name",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.leftPartnerLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "leftPartnerLine1", $$v);
      },
      expression: "form.leftPartnerLine1"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Phone",
      placeholder: "Phone",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.leftPhoneLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "leftPhoneLine", $$v);
      },
      expression: "form.leftPhoneLine"
    }
  })], 1)])])], 1)], 1), _c(VExpansionPanels, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c("span", {
    staticClass: "text-bold text-standalone-required"
  }, [_vm._v(" Right side on customs invoice ")])]), _c(VExpansionPanelContent, [_c("div", [_vm.order.importer.id > 0 ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary mr-2",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.loadRightSideWithImporter();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-copy mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Copy from importer ")], 1) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.loadRightSideWithDeliveryAddress();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-copy mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Copy from user delivery address ")], 1)], 1), _c("div", {
    staticClass: "dfwa-form"
  }, [_c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Title",
      placeholder: "title on right side (Ship to)",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.rightTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rightTitle", $$v);
      },
      expression: "form.rightTitle"
    }
  })], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Name",
      placeholder: "Name",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.rightNameLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rightNameLine", $$v);
      },
      expression: "form.rightNameLine"
    }
  })], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Address (main)",
      placeholder: "XX Street",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.rightAddressLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rightAddressLine1", $$v);
      },
      expression: "form.rightAddressLine1"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Address (line 2)",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.rightAddressLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rightAddressLine2", $$v);
      },
      expression: "form.rightAddressLine2"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Address (line 3)",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.rightAddressLine3,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rightAddressLine3", $$v);
      },
      expression: "form.rightAddressLine3"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Address (complement)",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.rightAddressComplement,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rightAddressComplement", $$v);
      },
      expression: "form.rightAddressComplement"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Address (city)",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.rightAddressCity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rightAddressCity", $$v);
      },
      expression: "form.rightAddressCity"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Address (country)",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.rightAddressCountry,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rightAddressCountry", $$v);
      },
      expression: "form.rightAddressCountry"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Tax ID",
      placeholder: "Tax ID # XX-XXXXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.rightTaxIdLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rightTaxIdLine", $$v);
      },
      expression: "form.rightTaxIdLine"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "License or Import permit",
      placeholder: "TTB permit # AA-B-XXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.rightPermitLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rightPermitLine", $$v);
      },
      expression: "form.rightPermitLine"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Bond ID",
      placeholder: "BOND # AAXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.rightPartnerLine3,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rightPartnerLine3", $$v);
      },
      expression: "form.rightPartnerLine3"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Partner ID",
      placeholder: "PWDBW ID : XXXXXXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.rightPartnerLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rightPartnerLine2", $$v);
      },
      expression: "form.rightPartnerLine2"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Partner name",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.rightPartnerLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rightPartnerLine1", $$v);
      },
      expression: "form.rightPartnerLine1"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Phone",
      placeholder: "Phone",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.rightPhoneLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rightPhoneLine", $$v);
      },
      expression: "form.rightPhoneLine"
    }
  })], 1)])])], 1)], 1), _c(VExpansionPanels, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c("span", {
    staticClass: "text-bold"
  }, [_vm._v("Bottom side on customs invoice")])]), _c(VExpansionPanelContent, [_c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.cleanBottomSide();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-eraser mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Clean ")], 1), _vm.order.importer.id > 0 ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary ml-2",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.loadBottomSideWithImporter();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-copy mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Copy from importer ")], 1) : _vm._e()], 1), _c("div", {
    staticClass: "dfwa-form"
  }, [_c("div", [_c(VTextField, {
    attrs: {
      label: "Title",
      placeholder: "title on bottom side (Seller)",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.bottomTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bottomTitle", $$v);
      },
      expression: "form.bottomTitle"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Name",
      placeholder: "Name",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.bottomNameLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bottomNameLine", $$v);
      },
      expression: "form.bottomNameLine"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Address (main)",
      placeholder: "XX Street",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.bottomAddressLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bottomAddressLine1", $$v);
      },
      expression: "form.bottomAddressLine1"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Address (city)",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.bottomAddressLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bottomAddressLine2", $$v);
      },
      expression: "form.bottomAddressLine2"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Tax ID",
      placeholder: "Tax ID # XX-XXXXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.bottomTaxIdLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bottomTaxIdLine", $$v);
      },
      expression: "form.bottomTaxIdLine"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Import permit",
      placeholder: "TTB permit # AA-B-XXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.bottomPermitLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bottomPermitLine", $$v);
      },
      expression: "form.bottomPermitLine"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Bond ID",
      placeholder: "BOND # AAXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.bottomPartnerLine3,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bottomPartnerLine3", $$v);
      },
      expression: "form.bottomPartnerLine3"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Partner ID",
      placeholder: "PWDBW ID : XXXXXXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.bottomPartnerLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bottomPartnerLine2", $$v);
      },
      expression: "form.bottomPartnerLine2"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Partner name",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.bottomPartnerLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bottomPartnerLine1", $$v);
      },
      expression: "form.bottomPartnerLine1"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Phone",
      placeholder: "Phone",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.bottomPhoneLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bottomPhoneLine", $$v);
      },
      expression: "form.bottomPhoneLine"
    }
  })], 1)])])], 1)], 1)], 1)])], 1), _c(VCardActions, {
    staticClass: "actions-bottom-container"
  }, [!_vm.isAdding ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      disabled: _vm.isValidating
    },
    on: {
      click: _vm.remove
    }
  }, [_vm._v(" Delete all custom data ")]) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      loading: _vm.isValidating,
      disabled: !_vm.form.valid
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.isAdding ? "Create" : "Save") + " ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };